import React from "react";

interface IOSToggleProps {
  isOn: boolean;
  onChange: (isOn: boolean) => void;
  disabled?: boolean;
  "data-testid"?: string;
}

export function IOSToggle({
  isOn,
  onChange,
  disabled = false,
  "data-testid": testId,
}: IOSToggleProps) {
  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
      }}
    >
      <input
        type="checkbox"
        checked={isOn}
        onChange={(e) => !disabled && onChange(e.target.checked)}
        disabled={disabled}
        data-testid={testId}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          opacity: 0,
          width: "51px",
          height: "31px",
          margin: 0,
          cursor: disabled ? "not-allowed" : "pointer",
          zIndex: 2,
        }}
      />
      <div
        style={{
          width: "51px",
          height: "31px",
          backgroundColor: isOn ? "#34C759" : "#E9E9EA",
          borderRadius: "16px",
          padding: "2px",
          cursor: disabled ? "not-allowed" : "pointer",
          transition: "background-color 0.2s ease",
          position: "relative",
          opacity: disabled ? 0.5 : 1,
          overflow: "hidden",
          flexShrink: 0,
          flexGrow: 0,
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            width: "27px",
            height: "27px",
            backgroundColor: "#FFFFFF",
            borderRadius: "50%",
            transform: `translateX(${isOn ? "20px" : "0"})`,
            transition: "transform 0.2s ease",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
            position: "absolute",
            top: "2px",
            left: "2px",
          }}
        />
      </div>
    </div>
  );
}
